import React from "react";

const TinInput = (props) => {
    let {run, pickup, onInputTin, handleFocus, isEditMode} = props;

    if(!run.isBaseCheckedIn || run.isComplete || !pickup.isTinLocation){
        return null;
    }
    else {
        return (
            <div className="row form-group form-inline mt-1 mb-1">
                <div className="col-12 input-group">
                    <span className="input-group-addon">Expected Tins: {pickup.expectedTins}</span>
                    <input className="form-control"
                           type="number"
                           disabled={!isEditMode}
                           onChange={onInputTin}
                           placeholder="Picked up"
                           value={pickup.numberOfTinsCollected == null ? 0 : pickup.numberOfTinsCollected}
                           onFocus={handleFocus}
                           style={{lineHeight: '3em', fontSize: 'large'}}
                    />
                </div>
            </div>
        );
    }
};

export default TinInput;